import { FilterItem } from '@ocean/types/dist/filter'
import { BaseVirtualEventSchedule } from 'modules/virtualClassrooms/manager/Schedules/types'

export enum ScheduleStatus {
  Upcoming,
  Past,
}

export enum ShowType {
  Own,
  All,
}

export type SchedulesFilterItems = {
  status: FilterItem
  showType: FilterItem
}

export type SchedulesFilterItemNames = keyof SchedulesFilterItems

export type SchedulesFilterItem = {
  name: SchedulesFilterItemNames
  value: FilterItem['value']
}

export type ListVirtualEventSchedules = {
  schedules: VirtualEventSchedule[]
}

export type VirtualEventSchedule = BaseVirtualEventSchedule & {
  eventId: Guid
  participants: number
  presenters: number
  waitList: number
}
